import React from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  MenuItem,
} from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

const TablePagination = ({
  page,
  totalPages,
  loading,
  onChange,
  showEntryOptions = [10, 25, 50, 100],
  entriesPerPage,
  onEntriesChange,
}) => {
  const handlePageChange = (newPage) => {
    if (newPage < 1) newPage = 1;
    if (newPage > totalPages) newPage = totalPages;
    onChange(newPage);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mt: 2,
      }}
    >
      {onEntriesChange && (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <TextField
            select
            label="Per Page"
            value={entriesPerPage}
            onChange={(e) => onEntriesChange(Number(e.target.value))}
            size="small"
            sx={{ width: 95 }}
          >
            {showEntryOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          border: "1px solid",
          borderColor: "primary.main",
          borderRadius: 1,
          px: 1,
        }}
      >
        <IconButton
          onClick={() => handlePageChange(page - 1)}
          disabled={loading || page <= 1}
          color="secondary"
          size="small"
        >
          <ChevronLeft />
        </IconButton>

        <Typography variant="body2" sx={{ mx: 1, color: "text.secondary" }}>
          Go to
        </Typography>

        <TextField
          type="number"
          value={page}
          onChange={(e) => {
            const value = parseInt(e.target.value, 10);
            if (!isNaN(value)) {
              handlePageChange(value);
            }
          }}
          size="small"
          slotProps={{
            htmlInput: {
              min: 1,
              max: totalPages,
              style: {
                textAlign: "center",
                padding: "2px 4px",
                width: 40,
              },
            },
          }}
          variant="outlined"
        />

        <Typography variant="body2" sx={{ mx: 1, color: "text.secondary" }}>
          of {totalPages}
        </Typography>

        <IconButton
          onClick={() => handlePageChange(page + 1)}
          disabled={loading || page >= totalPages}
          color="secondary"
          size="small"
        >
          <ChevronRight />
        </IconButton>
      </Box>
    </Box>
  );
};

export default TablePagination;
